/*---------------------------------------------------------------------------------------------
    *  Copyright (c) Microsoft Corporation. All rights reserved.
    *  Licensed under the MIT License. See License.txt in the project root for license information.
*--------------------------------------------------------------------------------------------*/

import { IFooterCategoryViewProps } from '@msdyn365-commerce-modules/footer/src/modules/footer-category';
import { Drawer, IModuleProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import React, { ReactNode } from 'react';
import { IFooterCategoryProps } from '../definition-extensions/footer-category.ext.props.autogenerated';

export const FooterCategoryView: React.FC<IFooterCategoryViewProps & IFooterCategoryProps<{}>> = props => {
    const { categories, FooterList, FooterListItem } = props;
    if (!categories || !categories.length) {
        return null;
    }
    const FooterContainer: IModuleProps = {
        moduleProps: props,
        className: classnames('ms-footer_module', props.config.className),
    };

    if (props.config.renderDrawer) {
        return (
            <Module {...FooterContainer}>
                {renderDesktop(props)}
                {renderMobile(props)}
            </Module>);
    } else {
        return (
            <Module {...FooterList} role='menu'>
                {categories.map((category: ReactNode, index: number) => {
                    return (
                        <Node {...FooterListItem} key={index} role='menuitem'>
                            {category}
                        </Node>
                    );
                })
                }
            </Module>
        );
    }
};

function renderDesktop(props: IFooterCategoryViewProps & IFooterCategoryProps<{}>): JSX.Element {
    const { categories, FooterListItem } = props;
    const DesktopFooterList: IModuleProps = {
        moduleProps: props,
        className: classnames('ms-footer__list-Desktop citta-footer-category-desktop', props.config.className),
        tag: 'ul',
        role: 'menu'
    };
    return (
        <Module {...DesktopFooterList}>
            <Node className='citta-footer-category-header'>
                {props.config.categoryName}
            </Node>
            {categories.map((category: ReactNode, index: number) => {
                return (
                    <Node {...FooterListItem} key={index} role='menuitem'>
                        {category}
                    </Node>
                );
            })
            }
        </Module>
    );
}

function renderMobile(props: IFooterCategoryViewProps & IFooterCategoryProps<{}>): React.ReactNode {
    const { categories } = props;
    const MobileFooterList: IModuleProps = {
        moduleProps: props,
        className: classnames('ms-footer__list-mobile citta-footer-category-mobile', props.config.className),
        tag: 'ul',
        role: 'menu'
    };
    return (
        <Module {...MobileFooterList}>
            <Drawer className='citta-footer-category-mobile1' openGlyph='fas fa-angle-up' closeGlyph='fas fa-angle-down' glyphPlacement='end' toggleButtonText={props.config.categoryName} toggleButtonProps={{ color: 'light', tag: 'button' }}>
                <div className='submenu-wrapper'>
                    {categories &&
                        categories.map((category, id2: number) => (
                            <div>
                                {category}
                            </div>
                        ))}
                </div>
            </Drawer>
        </Module>
    );
}

export default FooterCategoryView;